import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-close-stream',
  standalone: false,
  templateUrl: './close-stream.component.html',
  styleUrl: './close-stream.component.scss'
})
export class CloseStreamComponent {
  constructor(private dialogRef: MatDialogRef<CloseStreamComponent>) {}

  close(result: boolean) {
    this.dialogRef.close(result);
  }
}
